import { generateSkinDefaults } from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';
import { itemSkinParams } from './skinParams/itemSkinParams';
import { containerSkinParams } from './skinParams/containerSkinParams';
import { regular } from './skinParams/common';
import { dropdownContainerSkinParams } from './skinParams/dropdownContainerSkinParams';
import { dropdownMenuContainerSkinParams } from './skinParams/dropdownMenuContainerSkinParams';
import { dropdownMenuItemSkinParams } from './skinParams/dropdownMenuItemSkinParams';
import { dropdownMenuSubItemSkinParams } from './skinParams/dropdownMenuSubItemSkinParams';

export const skinDefinition: Record<string, SkinDefinition> = {
  'wixui.skins.Menu': {
    ...containerSkinParams,
    ...itemSkinParams,
    ...dropdownContainerSkinParams,
    ...dropdownMenuContainerSkinParams,
    ...dropdownMenuItemSkinParams,
    ...dropdownMenuSubItemSkinParams,
    'spacing-between-label-and-dropdown-icon': {
      type: 'SIZE',
      defaultValue: '0px',
      state: regular,
    },
    'menu-items-main-axis-gap': {
      type: 'SIZE',
      defaultValue: '0px',
      state: regular,
    },
    'menu-items-cross-axis-gap': {
      type: 'SIZE',
      defaultValue: '0px',
      state: regular,
    },
  },
};

export default generateSkinDefaults(skinDefinition);
